export default __webpack_public_path__ + "static/avenir-next-regular-ff5d7906c1e85b594fc55e697296f5ec.woff";